export const statusOptions: string[] = [
  "要対応",
  "要注意観察中"
];

export const unhandledAlertOptions: string[] = [
  "頻回アラート",
  "リスクアセスメント陽性",
  "ハイリスク疑いの報告"
];

export const historyConditionOptions: string[] = [
  "頻回アラート",
  "自治体連携実施",
  "頻回制御警告メール送信",
  "ハイリスク疑いの報告",
  "リスクアセスメント陽性",
  "児相連携実施",
  "頻回制御実施"
];